<template slot="main">
  <el-dialog
    :visible.sync="open"
    :before-close="close">
    <div>
      <h2 class="text-xl mb-1" style="text-align:center">Total views and actions made</h2>
      <div class="bg-white rounded shadow p-8">
        <div class="mb-2">
          <div class="mt-2">
            <canvas id="graph2"></canvas>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Chart } from 'chart.js/auto'

export default {
  name: 'BannerStats',

  props: {
    open: {
      type: Boolean,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loaded: false,
      chart: null
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('banners', {
      getById: 'getById',
      waves: 'banners'
    }),

    banner () {
      return this.getById(this.id)
    }
  },

  methods: {
    ...mapActions('banners', ['loadBanner', 'getBannerStats']),
    initBanner () {
      this.loadBanner({id: this.id}).then((banner) => {
        this.getBannerStats({id: this.id}).then((data) => {
          // Chart 2
          var horizontalBarChartData = {
            labels: [''],
            datasets: [{
              label: 'Number of view',
              backgroundColor: 'rgb(255, 99, 132, 0.5)',
              borderColor: 'rgb(255, 99, 132)',
              data: [data.results.views.total],
              borderWidth: 1
            }, {
              label: 'Unique view number',
              backgroundColor: 'rgb(54, 162, 235, 0.5)',
              borderColor: 'rgb(54, 162, 235)',
              data: [data.results.views.unique],
              borderWidth: 1
            }, {
              label: 'Number of links clicked',
              backgroundColor: 'rgb(53, 212, 56, 0.5)',
              borderColor: 'rgb(53, 212, 56)',
              data: [data.results.link_pressed.total],
              borderWidth: 1
            }, {
              label: 'Number of unique links clicked',
              backgroundColor: 'rgb(222, 235, 52, 0.5)',
              borderColor: 'rgb(222, 235, 52)',
              data: [data.results.link_pressed.unique],
              borderWidth: 1
            }]
          }

          const ctx2 = document.getElementById('graph2')
          if (ctx2) {
            this.chart = new Chart(ctx2, {
              type: 'bar',
              data: horizontalBarChartData,
              options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                indexAxis: 'y',
                elements: {
                  rectangle: {
                    borderWidth: 2
                  }
                },
                responsive: true,
                legend: {
                  position: 'bottom'
                },
                title: {
                  display: false
                },
                scales: {
                  x: {
                    beginAtZero: true
                  }
                },
                tooltips: {
                  callbacks: {
                    title: function () {}
                  }
                }
              }
            })
          }
        })
      })
    }
  },

  mounted () {
    this.initBanner()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/banners/ui/modal/stats.vue